// extracted by mini-css-extract-plugin
export default {"descriptionSection":"styles_descriptionSection__w1h4d","description":"styles_description__GTIBH"};